import {defineStore} from "pinia/dist/pinia";

export const useUserStore = defineStore('UserStore', {
    state() {
        return {}
    },
    getters: {},
    actions: {}
})